import {axiosGetHandler, axiosPostHandler} from './config'
import {extractAPIValues} from '_lib/utils/utils'
const {BASE_API} = extractAPIValues()

//对x隐身
export function getInvisibleList (args) {
  let url = BASE_API + '/chatroom/v2/settings/friend/view_blocked'
  return axiosGetHandler(url, args)
}

//修改用户账号设置
export function  updateAccountSetting(args, formdata) {
  let url = BASE_API + '/chatroom/v2/settings/account/update'
  return axiosPostHandler(url, args, formdata)
}

//获取用户账号设置
export function getAccountSetting(args) {
  let url = BASE_API + '/chatroom/v2/settings/account'
  return axiosGetHandler(url, args)
}

//修改针对某个好友设置
export function updateFriendSetting(args, formdata) {
  let url = BASE_API + '/chatroom/v2/settings/friend/update'
  return axiosPostHandler(url, args, formdata)
}

//获取针对某个好友设置
export function getFriendSettings(args) {
  let url = BASE_API + '/chatroom/v2/settings/friend/settings'
  return axiosGetHandler(url, args)
}

//获取反馈ID
export function getFeedbackID(args) {
  let url = BASE_API + '/chatroom/v2/settings/feedback_id'
  return axiosGetHandler(url, args)
}

// 获取常见问题 前五条
export function getFeedback(args) {
  let url = BASE_API + '/chatroom/v2/settings/help_center?offset=0&limit=5'
  return axiosGetHandler(url, args)
}

// 获取极简模式版本
export function getMinimalVersion (args) {
  let url = BASE_API + '/chatroom/v2/common/minimal/version/check'
  return axiosGetHandler(url, args)
}

// 重置设置
export function resetSettings (args, formdata) {
  let url = BASE_API + '/chatroom/v2/settings/account/reset'
  return axiosPostHandler(url, args, formdata)
}

// 恢复设置
export function restoreSettings (args, formdata) {
  let url = BASE_API + '/chatroom/v2/settings/account/restore'
  return axiosPostHandler(url, args, formdata)
}

// 后台拉起的通用Query交互
export function universalQuery(args, formdata) {
  let url = BASE_API + 'chatroom/v2/popup_event'
  return axiosPostHandler(url, args, formdata)
}